import common from './common.json';

export const enLocales: any = {
  common,
};
